import React from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { Box, Button } from '../../../../../../components/mui/Core/index'
import { resetUpdateRoleConfirm, setCurrentStep } from '../../update-user-role-slice'
import Constants from '../../../../../../constants/en.json'

function UpdateUserRoleNavigation({ handleCloseAction, handleSubmitAction }) {
  const dispatch = useDispatch()
  const selectedRole = useSelector((state) => state.updateUserRole.selectedRole)
  const totalSteps = useSelector((state) => state.updateUserRole.totalSteps)
  const currentStep = useSelector((state) => state.updateUserRole.currentStep)
  const isRoleUpdateConfirmed = useSelector((state) => state.updateUserRole.isUpdateRoleConfirmed)
  const isLastStep = currentStep === totalSteps

  const isNextActionDisabled = () => {
    switch (currentStep) {
      case 1:
        return !selectedRole
      case 2:
        return !isRoleUpdateConfirmed
      default:
        return true
    }
  }

  const handleBackAction = () => {
    const previousStep = currentStep - 1 >= 1 ? currentStep - 1 : currentStep
    dispatch(setCurrentStep(previousStep))
    if (currentStep === 2) {
      dispatch(resetUpdateRoleConfirm())
    }
  }

  const handleNextAction = () => {
    const nextStep = currentStep + 1 <= totalSteps ? currentStep + 1 : currentStep
    if (!isLastStep) {
      dispatch(setCurrentStep(nextStep))
    }
  }

  const handleCancelAction = () => {
    handleCloseAction()
  }

  const rootStyle = { display: 'flex' }
  const rightButtonGroupStyle = { display: 'flex', width: '100%', justifyContent: 'right' }
  const nextActionButtonContainerStyle = { ml: '8px' }
  const submitActionButtonStyle = { minWidth: '174px' }

  return (
    <Box sx={rootStyle}>
      {currentStep > 1 && (
        <Box>
          <Button color='secondary' variant='outlined' onClick={handleBackAction}>
            {Constants.userManagement.updateRole.BACK}
          </Button>
        </Box>
      )}
      <Box sx={rightButtonGroupStyle}>
        <Box>
          <Button color='secondary' variant='outlined' onClick={handleCancelAction}>
            {Constants.userManagement.updateRole.CANCEL}
          </Button>
        </Box>

        <Box sx={nextActionButtonContainerStyle}>
          {!isLastStep && (
            <Button
              disabled={isNextActionDisabled()}
              variant='contained'
              color='secondary'
              onClick={handleNextAction}
            >
              {Constants.userManagement.updateRole.NEXT}
            </Button>
          )}
          {isLastStep && (
            <Button
              sx={submitActionButtonStyle}
              variant='contained'
              color='secondary'
              onClick={handleSubmitAction}
              disabled={isNextActionDisabled()}
            >
              {Constants.userManagement.updateRole.UPDATE_ROLE_BUTTON.toUpperCase()}
            </Button>
          )}
        </Box>
      </Box>
    </Box>
  )
}

UpdateUserRoleNavigation.propTypes = {
  handleCloseAction: PropTypes.func,
  handleSubmitAction: PropTypes.func,
}

export default UpdateUserRoleNavigation
